import crmWS from "../ws/UniversalSocket.ts";

export class CtiBox {

	constructor(callInfo) {
		this.callInfo = callInfo;
		this.closableSpan = null;
		this.areaComment = null;
		this.divBox = this.generateCtiBox();
		//start counter
		if(this.callInfo.call_state === 2) { //actual state is CONNECTED
			this.startClock();
		}


		//register events
		this.divBox.addEventListener('mouseenter', this.showCloseIcon.bind(this));
		this.divBox.addEventListener('mouseleave', this.hideCloseIcon.bind(this));
		this.areaComment.addEventListener('keyup', this.sendNewComment.bind(this));
		this.closableSpan.addEventListener('click', this.closeBox.bind(this));

	}

	setNewCallInfo(newCallInfo) {
		this.callInfo = newCallInfo;
	}

	toElement() {
		return this.divBox;
	}

	getCallInfo() {
		return this.callInfo;
	}

	generateCtiBox() {
		const uid = this.callInfo.uid;
		var box = document.createElement('div');
		box.setAttribute('style', 'position:relative;');
		box.id = 'ctiBox_' + uid;
			var table = document.createElement('table');
			table.setAttribute('id', 'ctiBoxTable_' + uid);
			table.setAttribute('class', 'callInfoTable '+CtiBox.getBoxClass(this.callInfo)); //css
				var thed = document.createElement('thead');
				var tbdy = document.createElement('tbody');

					//closable div
					var closableDiv = document.createElement('div');
					closableDiv.setAttribute('id', 'closeInfoTable_' + uid);
					closableDiv.setAttribute('style', 'position: absolute;right: 1px;');
						this.closableSpan = document.createElement('span');
						this.closableSpan.setAttribute('class', 'fi');
						this.closableSpan.setAttribute('style', 'display:none;');
						this.closableSpan.innerHTML = Icon.entity("close");
					closableDiv.appendChild(this.closableSpan);
					box.appendChild(closableDiv);

					//customer header row
					var headerTr = document.createElement('tr');
					headerTr.setAttribute('class', 'ctiBoxHeader_' + uid);
						var th = document.createElement('th');
						th.setAttribute('style', 'padding: 3px 4px;');
							var hrefContact = document.createElement('a');
							hrefContact.setAttribute('href', 'editContact.do?id='+this.callInfo.communication);
								var span = document.createElement('span');
								span.setAttribute('class', 'fi');
								span.setAttribute('id', 'callInfoIcon_'+uid);
								span.innerHTML = Icon.entity(CtiBox.getIcon(this.callInfo.direction))+"&nbsp;";
							hrefContact.appendChild(span);
						th.appendChild(hrefContact);

							var hrefCustomer = document.createElement('a');
							if(this.callInfo.customer>0) {
								hrefCustomer.setAttribute('href', 'editCustomer.do?id='+this.callInfo.customer);
								hrefCustomer.appendChild(document.createTextNode(this.callInfo.customerTitle));
							} else { //unknown number
								hrefCustomer.setAttribute('href', 'convertObject.do?destType=7&srcType=6&srcId='+this.callInfo.communication+'&connect=true');
								hrefCustomer.appendChild(document.createTextNode(this.callInfo.call_address));
							}

						th.appendChild(hrefCustomer);
					headerTr.appendChild(th);
				thed.appendChild(headerTr);
				if(this.callInfo.person>0) {
					var trPerson = document.createElement('tr');
					trPerson.setAttribute('class', 'ctiBoxHeader_'+uid);
						var thPerson = document.createElement('th');
						thPerson.setAttribute('style', 'padding-left:24px;');
							var hrefPerson = document.createElement('a');
							hrefPerson.setAttribute('href', 'editCustomer.do?id='+this.callInfo.person);
							hrefPerson.appendChild(document.createTextNode(this.callInfo.personTitle));
						thPerson.appendChild(hrefPerson);
					trPerson.appendChild(thPerson);
					thed.appendChild(trPerson);
				}
				if(this.callInfo.branch>0) {
					var trBranch = document.createElement('tr');
					trBranch.setAttribute('class', 'ctiBoxHeader_'+uid);
						var thBranch= document.createElement('th');
						thBranch.setAttribute('style', 'padding-left:24px;');
							var hrefBranch = document.createElement('a');
							hrefBranch.setAttribute('href', 'editCustomer.do?id='+this.callInfo.branch);
							hrefBranch.appendChild(document.createTextNode(this.callInfo.branchTitle));
						thBranch.appendChild(hrefBranch);
					trBranch.appendChild(thBranch);
					thed.appendChild(trBranch);
				}

				//clock row
				var trClocks = document.createElement('tr');
					var tdClocks = document.createElement('td');
					tdClocks.setAttribute('style', 'padding: 3px 4px;');
						var spanClock1 = document.createElement('span');
							spanClock1.setAttribute('class', 'fi');
							spanClock1.innerHTML = Icon.entity('clock');
						tdClocks.append(spanClock1);
						var spanClock2 = document.createElement('span');
							spanClock2.innerHTML = "&nbsp;"+this.callInfo.call_start+"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
						tdClocks.append(spanClock2);

						var spanStopWatch = document.createElement('span');
						spanStopWatch.setAttribute('id', 'ctiBoxStopWatch_' + uid);
						if(!this.callInfo.wasConnected) spanStopWatch.setAttribute('style', 'display:none;'); //was connected
							var spanClock3 = document.createElement('span');
								spanClock3.setAttribute('class', 'fi');
								spanClock3.setAttribute('style', 'margin-left:10px;');
								spanClock3.innerHTML = Icon.fi("stopwatch");
							spanStopWatch.append(spanClock3);
							var spanClock4 = document.createElement('span');
								spanClock4.innerHTML = "&nbsp;"+this.callInfo.call_durationTime;
							spanStopWatch.append(spanClock4);
						tdClocks.append(spanStopWatch);

				trClocks.append(tdClocks);
				tbdy.appendChild(trClocks);

				//fragment
				if(this.callInfo.htmlFragment) {
					var trFragment = document.createElement('tr');
						var tdFragment = document.createElement('td');
						tdFragment.setAttribute('colspan', '2');
						tdFragment.innerHTML = this.callInfo.htmlFragment;
					trFragment.appendChild(tdFragment);
					tbdy.appendChild(trFragment);
				}

				//comment box
				var trComment = document.createElement('tr');
				trComment.setAttribute('id', 'callInfoTrComment_'+uid);
				if(!this.callInfo.wasConnected) trComment.setAttribute('style', 'display:none;'); //was connected
				var tdComment = document.createElement('td');
					this.areaComment = document.createElement('textarea');
					this.areaComment.setAttribute('id', 'comment_'+uid);
					this.areaComment.setAttribute('name', 'comment_'+uid);
					this.areaComment.setAttribute('style', 'height:42px;');
					this.areaComment.innerHTML = this.callInfo.comment;
				tdComment.appendChild(this.areaComment);
				trComment.appendChild(tdComment);
				tbdy.appendChild(trComment);
			table.appendChild(thed);
			table.appendChild(tbdy);
		box.appendChild(table);
		return box;
	}

	static sendToServer(msg) {

	}

	static changeState(newInfo, oldInfo) {
		const uid = newInfo.uid;
		var table = document.getElementById('ctiBoxTable_' + uid);
		table.classList.remove("cti-active", "cti-ringing", "cti-missed", "cti-info");
		table.classList.add(CtiBox.getBoxClass(newInfo));

		//comment box
		if(newInfo.wasConnected && !oldInfo.wasConnected) { //only 1x by change state
			var trComment = document.getElementById('callInfoTrComment_'+uid);
			trComment.setAttribute('style', 'display: table-row;');

			var spanStopWatch = document.getElementById('ctiBoxStopWatch_'+uid);
			spanStopWatch.setAttribute('style', 'display: inline;');
		}
	}


	// int		STATE_RINGING = 1;
	// int		STATE_CONNECTED = 2;
	// int		STATE_REDIRECTED = 3;
	// int		STATE_END = 4;
	//
	// int		STATE_MORE_TERMINAL_RINGING = 5;
	// int		STATE_PARTLY_END = 6;

	static getBoxClass(callInfo) {
		let className;
		switch (callInfo.call_state) {
			case 1:
			case 5:
				className = 'cti-active';
				break;
			case 2:
			case 3:
				className = 'cti-ringing';
				break;
			case 6:
				className = 'cti-missed';
				break;
			case 4:
			default:
				if (callInfo.call_duration > 0) className = 'cti-info';
				else className = 'cti-missed';
				break;
		}
		return className;
	}

	static getIcon(direction)
	{
		if(direction==="INCOMING") return 'call-in';
		else if(direction==="OUTGOING") return 'call-out';
		else return 'phone';
	}


	startTimer() {
		var spanStopWatch = document.getElementById('ctiBoxStopWatch_'+this.callInfo.uid);
		if(spanStopWatch !== null) {
			var childSpanTime = spanStopWatch.getElementsByTagName('span')[2];

			var diffTime = new Date().getTime() - this.callInfo.call_connectedTimestamp;
			//console.log('for '+this.callInfo.uid+" time: "+diffTime);
			var dateObj = new Date(diffTime);
			var minutes = dateObj.getUTCMinutes();
			var seconds = dateObj.getSeconds();
			var timeString = minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');
			childSpanTime.innerHTML = "&nbsp;"+timeString;
		} else console.log('span is null');
	}

	startClock() {
		this.timer = setInterval(this.startTimer.bind(this), 1000);
	}

	stopClock() {
		clearInterval(this.timer);
	}

	showCloseIcon() {
		this.closableSpan.setAttribute('style', 'display:inherite;cursor: pointer;');
	}

	hideCloseIcon() {
		this.closableSpan.setAttribute('style', 'display:none;');
	}

	sendNewComment() {
		var uid = this.callInfo.uid;
		if(this.areaComment !== null) {
			var msg = this.areaComment.value;
			crmWS.send("cti", "cti", {
				action: "NEW_COMMENT",
				uid: uid,
				comment: msg
			});
		}
	}

	closeBox() {
		var uid = this.callInfo.uid;
		if(this.areaComment !== null) {
			var msg = this.areaComment.value;
			crmWS.send("cti", "cti", {
				action: "CLOSE_BOX",
				uid: uid,
				comment: msg
			});
		}
		this.stopClock.bind(this);
		this.divBox.remove();

	}
}



